import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

const dotFlashing = keyframes`
  0% { opacity: 0.2; }
  50%, 100% { opacity: 1; }
`;

interface ThreeDotLoaderProps {
  label?: string;
  color?: string;
}

const ThreeDotLoader: React.FC<ThreeDotLoaderProps> = ({
  label = "Queued",
  color = "#014361",
}) => {
  return (
    <Stack
      textAlign={"right"}
      direction="row"
      alignItems="center"
      spacing={0.5}
    >
      <Typography color={color} fontWeight="light">
        {label}
      </Typography>
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            width: "4px",
            height: "4px",
            borderRadius: "50%",
            backgroundColor: color,
            animation: `${dotFlashing} 1s infinite linear`,
            animationDelay: `${index * 0.2}s`,
          }}
        />
      ))}
    </Stack>
  );
};

export default ThreeDotLoader;
